<template>
  <div name="Information">
    <i class="fa fa-info-circle info"
      @mouseover="infoDisplay = true" 
      @mouseleave="infoDisplay = false"
    ></i>
    <div class="infobox" :style="extraStyles" v-show="infoDisplay">
      <p class="infotext"> {{ infoText }} </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'information',
  props: {
    infoText: {type: String, required: true},
    extraStyles: String
  },
  data () {
    return {
      infoDisplay: false
    }
  }
}
</script>
<style>
.info {
  margin: 5px;
  padding: 5px;
  padding-left: 16px;
}
.info:hover {
  cursor: help;
  color: #a5181b;
}
.infobox {
  /* right: 0px;
  width: 250px; */
  z-index: 1000;
  position: absolute;
  background-color: white;
  border-width: 1px;
  border-style: solid;
  border-radius: 4px;
  border-color: rgb(100,100,100);
}
.infotext {
  padding: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/plugins/Information.vue